<div class="table-view">
  <p-toolbar>
    <ng-template pTemplate="left">
      <p-button
        severity="info"
        label="Add Rule"
        [disabled]="sourceAccountsLoading"
        icon="pi pi-plus"
        (click)="addRule()"/>
    </ng-template>
    <ng-template pTemplate="right">
      <span class="p-input-icon-left search-filter">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          [(ngModel)]="searchValue"
          (input)="dt.filterGlobal($event.target.value, 'contains')"
          placeholder="Search..."/>
      </span>
    </ng-template>
  </p-toolbar>
  <p-table
    #dt
    class="custom-table"
    [value]="sharedOfferSetsRules"
    [scrollable]="true"
    styleClass="p-datatable-gridlines"
    [rowHover]="true"
    [globalFilterFields]="globalFilterFields">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="ruleName">
          Rule Name
          <p-sortIcon field="ruleName"/>
        </th>
        <th pSortableColumn="sourceAccount.name">
          Source Account
          <p-sortIcon field="sourceAccount.name"/>
          <p-columnFilter
            field="sourceAccount"
            matchMode="in"
            display="menu"
            [showMatchModes]="false"
            [showOperator]="false"
            [showAddButton]="false">
            <ng-template pTemplate="filtericon">
              <i class="pi pi-filter custom-filter-icon"></i>
            </ng-template>
            <ng-template pTemplate="header">
              <div class="source-account-filter">
                <span><b>Select Source Account</b></span>
              </div>
            </ng-template>
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-multiSelect [ngModel]="value" [options]="sourceAccounts" placeholder="Any"
                             (onChange)="filter($event.value)" optionLabel="name">
                <ng-template let-option pTemplate="item">
                  <div>
                    <span>{{ option.name }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
        </th>
        <th>Account Filters</th>
        <th>Offer Set Filters</th>
        <th>Edit / Delete</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rule let-ruleIndex="rowIndex">
      <tr (click)="onRowClick(rule)" style="cursor: pointer;">
        <td>
          <div class="preview-button-field">
            <label class="table-header" (mouseover)="op.toggle($event)" (mouseleave)="op.hide()">{{ rule.ruleName }}
              <span class="pi pi-info-circle"></span>
            </label>
            <button
              icon="pi pi-eye"
              pButton
              pTooltip="Preview Applied Filters"
              (click)="previewRule(rule); $event.stopPropagation();"
              class="p-button-info search-filter preview-button">
            </button>
          </div>
          <p-overlayPanel #op>
            <div class="flex flex-column gap-3 w-25rem">
              <div>
                <span>Last Modified By:
                  <b>{{ rule.lastModifiedUser }}</b>
                </span>
                <br>
                <span>Last Modified:
                  <b>{{ rule.lastModified | date:'shortDate':'UTC' }}</b>
                </span>
                <br>
                <span>Created:
                  <b>{{ rule.created  | date:'shortDate': 'UTC' }}</b>
                </span>
              </div>
            </div>
          </p-overlayPanel>
        </td>
        <td>
          <label class="table-header">{{ rule.sourceAccount.name }}</label>
        </td>
        <td>
          <div class="filter-field-style"
               [class.with-show-more]="getFilters(rule,'account').length > tagsPerRow">
            <div *ngIf="getFilters(rule,'account').length === 0">
              <span class="not-found-field"><i>No Account Filters</i></span>
            </div>
            <ng-container *ngFor="let filter of getFilterSegments(rule, ruleIndex, 'account')">
              <span class="custom-p-filter">
                {{ filter | offerSetRuleSummary:filterDefinitions:makes }}
              </span>
            </ng-container>
            <button *ngIf="getFilters(rule,'account').length > tagsPerRow"
                    (click)="toggleShowMore(ruleIndex, 'account'); $event.stopPropagation();"
                    class="show-more-btn">
              {{ getShowMoreLessText(rule, ruleIndex, 'account') }}
            </button>
          </div>
        </td>
        <td>
          <div class="filter-field-style"
               [class.with-show-more]="getFilters(rule,'offerSet').length > tagsPerRow">
            <div *ngIf="getFilters(rule,'offerSet').length === 0">
              <span class="not-found-field"><i>No Offer Set Filters</i></span>
            </div>
            <ng-container *ngFor="let filter of getFilterSegments(rule, ruleIndex, 'offerSet')">
             <span class="custom-p-filter">
                {{ filter | offerSetRuleSummary:filterDefinitions:makes }}
              </span>
            </ng-container>
            <button *ngIf="getFilters(rule,'offerSet').length > tagsPerRow"
                    (click)="toggleShowMore(ruleIndex, 'offerSet'); $event.stopPropagation();"
                    class="show-more-btn">
              {{ getShowMoreLessText(rule, ruleIndex, 'offerSet') }}
            </button>
          </div>
        </td>
        <td>
          <p-button
            icon="pi pi-pencil"
            severity="info"
            [disabled]="sourceAccountsLoading"
            class="p-button-info search-filter"
            (click)="editRule(rule); $event.stopPropagation();">
          </p-button>
          <p-button
            icon="pi pi-trash"
            severity="danger"
            class="p-button-danger search-filter"
            (click)="deleteRule($event, rule); $event.stopPropagation();">
          </p-button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td class="not-found-field" colspan="7"><i>No rules found</i></td>
      </tr>
    </ng-template>
  </p-table>
</div>
